import React, { useState } from 'react';
import InputText from 'src/components/InputText/InputText';

import AiCommonModal from './AiCommonModal';

interface IProps {
    step: number;
    totalSteps: number;
    onNext: (weight: string, linearFootage: string) => void;
    onBack: () => void;
    onClose: () => void;
}

const TotalWeightCard = ({ step, totalSteps, onNext, onBack, onClose }: IProps) => {
    const [weight, setWeight] = useState('');
    const [linearFootage, setLinearFootage] = useState('');

    return (
        <AiCommonModal
            title={
                <div className="flex items-center justify-between w-full">
                    <span>What&apos;s the total weight and linear footage?</span>
                    <span className="text-gray400 text-xs font-normal">
                        {step}/{totalSteps}
                    </span>
                </div>
            }
            agent="kate"
            handleClose={onClose}
            secondaryBtnText="Back"
            secondaryBtnOnClick={onBack}
            primaryBtnText="Next"
            primaryBtnOnClick={() => onNext(weight, linearFootage)}
            primaryBtnDisabled={!weight.trim() || !linearFootage.trim()}
        >
            <p className="text-gray500 text-xs leading-[1.5] font-normal mb-3">Please enter the total weight and the amount of trailer space required for your shipment.</p>
            <div className="space-y-2">
                <InputText inputType="number" placeholder="Enter weight" value={weight} onChangeFunc={(e) => setWeight(e.target.value)} />
                <InputText inputType="number" placeholder="Enter linear footage" value={linearFootage} onChangeFunc={(e) => setLinearFootage(e.target.value)} />
            </div>
        </AiCommonModal>
    );
};

export default TotalWeightCard;
